<nz-page-header class="site-page-header" nzTitle="Custom Summary Report"></nz-page-header>
 <div class="" nz-flex nzJustify="flex-end" style="float: right; margin-right: 20px;">
   <nz-breadcrumb [nzAutoGenerate]="true" nzSeparator=">"  >
     <nz-breadcrumb-item>
       <a [routerLink]="['']"> <span nz-icon nzType="appstore" nzTheme="outline"></span></a>
     </nz-breadcrumb-item>
     <nz-breadcrumb-item>
       <a [routerLink]="[' ']"> <span nz-icon nzType="user-add" nzTheme="outline"></span></a>
     </nz-breadcrumb-item>
   </nz-breadcrumb>
 </div>
<nz-card style="width: 100%; margin-top: 1.5rem; ">
<h5 nz-typography>Filters</h5>
<form nz-form  class="" style="margin-top: 2rem; margin-bottom: 2rem;">
    <div nz-row [nzGutter]="12" nzAlign="bottom" >
        <div nz-col [nzSpan]="4">
            <nz-form-control nzErrorTip="Select user type">
                <label for="user type"> Select Reseller</label>
                <nz-select id="usertype"  formControlName="usertype" nzPlaceHolder="Select a user type" >
                    <nz-option nzValue="client" nzLabel="Client"></nz-option>
                    <nz-option nzValue="seller" nzLabel="Seller"></nz-option>
                    <nz-option nzValue="reseller" nzLabel="Reseller"></nz-option>   
                </nz-select>
            </nz-form-control>
        </div>
        <div nz-col [nzSpan]="4">
            
            <nz-form-control nzErrorTip="Select user type">
                <label for="user type"> Select Seller</label>
                <nz-select id="usertype"  formControlName="usertype" nzPlaceHolder="Select a user type" >
                    <nz-option nzValue="client" nzLabel="Client"></nz-option>
                    <nz-option nzValue="seller" nzLabel="Seller"></nz-option>
                    <nz-option nzValue="reseller" nzLabel="Reseller"></nz-option>   
                </nz-select>
            </nz-form-control>
        </div>
        <div nz-col [nzSpan]="4">
            
            <nz-form-control nzErrorTip="Select user type">
                <label for="user type"> Select Client </label>
                <nz-select id="usertype"  formControlName="usertype" nzPlaceHolder="Select a user type" >
                    <nz-option nzValue="client" nzLabel="Client"></nz-option>
                    <nz-option nzValue="seller" nzLabel="Seller"></nz-option>
                    <nz-option nzValue="reseller" nzLabel="Reseller"></nz-option>   
                </nz-select>
            </nz-form-control>
        </div>

        <div nz-col [nzSpan]="6" class="ml">
            
            <nz-form-control>
                <label for="Expiry">Expiry Date*</label>
                <nz-range-picker ></nz-range-picker>
            </nz-form-control>
        </div>

        <div nz-col [nzSpan]="6" >
            <button nz-button nzType="primary" class="btn-gap">Search</button>
            <button nz-button nzType="default" nzDanger class="btn-gap">Research</button>
            <button nz-button nzType="primary" type="button" class="btn-gap">Download</button>
        </div>
    
     
    </div>

    

    </form>

    <nz-table
    nzShowSizeChanger
    [nzTotal]="total"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageIndex"
  >
    <thead>
      <tr>
        <th nzColumnKey="summaryDate" [nzSortFn]="true">User Name</th>
        <th nzColumnKey="totalRequested" [nzSortFn]="true">Summary Date</th>
        <th nzColumnKey="totalRejected" [nzSortFn]="true">Total Request</th>
        <th nzColumnKey="totalSubmit" [nzSortFn]="true">Total Rejected</th>
        <th nzColumnKey="totalRequested" [nzSortFn]="true">Total Sumbit</th>
        <th nzColumnKey="totalFailed" [nzSortFn]="true">Total Delivered</th>
        <th nzColumnKey="totalAwaited" [nzSortFn]="true">Total Failed</th>
        <th nzColumnKey="totalAwaited" [nzSortFn]="true">Total Awaited</th>
      </tr>
    </thead>
    <tbody>
      
    </tbody>
  </nz-table>





</nz-card>